import React, { memo, useEffect } from 'react'
import ProductDetailsForm from './product-details/ProductDetailsForm'
import { useDispatch } from 'react-redux';
import { setupSolarProductDetails } from '../../../stores/slices/solar-product-details-slice';

type Props = {}

const CreateProduct: React.FC<Props> = memo((props: Props) => {
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(setupSolarProductDetails());
    }, [dispatch])

    return (
        <ProductDetailsForm />
    )
})

export default CreateProduct